import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/explore/page.tsx");
